import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconFormatUnderline$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFormatUnderline extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '5e8ea5ab3083a60193809ea002453a01ee9e0ac6', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'ca3ed24e451265ff5df64a55ef2722b799e40ffb', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'ce3dd71d079546a3ab15fa88ba196b83a9a67a64', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M6 4.5v5.93c0 3.22 1.94 5.07 4.99 5.07s5-1.85 5-5.07V4.5a.5.5 0 0 0-.5-.5H15a.5.5 0 0 0-.49.5v6.27A3.34 3.34 0 0 1 11 14.15a3.37 3.37 0 0 1-3.5-3.38V4.5A.5.5 0 0 0 7 4h-.5a.5.5 0 0 0-.5.5m.5 12.97a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-format-underline", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-format-underline"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-format-underline":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFormatUnderline$1);
            }
            break;
    } });
}

const CosmosIconFormatUnderline = CosmosIconFormatUnderline$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFormatUnderline, defineCustomElement };
